import { number, object, string } from 'idonttrustlikethat'

const dataScienceScore = object({
  id: number,
  okta_id: string,
  rank: string,
  score: number,
  state: string.nullable(),
  username: string,
  firstname: string.nullable()
})

const scoreState = object({
  id: number,
  score: number.nullable(),
  state: string.nullable()
}).nullable()

const scorePost = object({
  id: number,
  state: string
})

const dataScienceScorePost = object({ data: scorePost })

type DataScienceScore = typeof dataScienceScore.T
type DataScienceScorePost = typeof dataScienceScorePost.T
type Score = typeof dataScienceScore.T
type ScoreState = typeof scoreState.T

export { dataScienceScore, dataScienceScorePost, scoreState }

export type { DataScienceScore, DataScienceScorePost, Score, ScoreState }
